import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import CommonSDF from "components/commonSDF/CommonSDF";

const CommonSubHeader = (props) => {
  const {
    navigation,
    buttonName,
    filter,
    defaultStatus,
    filterData,
    billingSubHeader,
    dashboardSubHeader,
    selectCity,
    onFilterChange,
    onRestFilter,
    onSearchQuery,
    onSelectDateRange,
    tabName,
    defaultLocation,
    search,
    tab,
    locValue,
  } = props;

  const handleAuto = (e, value) => {
    console.log("Selected location:", value);
    props?.onInputChange(e, value);
  };
  return billingSubHeader || dashboardSubHeader ? (
    <Grid
      item lg={12} md={12} sm={12} xs={12}
      container alignItems={"center"}
      sx={{justifyContent:{lg:'flex-end',md:'flex-end',sm:'flex-start',xs:'flex-start'}}}
      gap={1}
    >
      {props?.userProfileData?.Company?.ServiceCity?.id && locValue?.id ? (
        <Grid>
          <>
            <TextField className="customDefaultValue" size="small" disabled={true} value={props?.userProfileData?.Company?.ServiceCity?.name} />
          </>
        </Grid>
      ) : (
        <>
          {selectCity && (
            <Grid>
              <Autocomplete
                value={locValue?.id && locValue}
                size="small"
                onChange={handleAuto}
                className="customDefaultValue"
                id="controllable-states-demo"
                getOptionLabel={(option) => option.name}
                options={props?.Location || []}
                renderInput={(params) => (
                  <TextField sx={{ height: '40px' }} {...params} placeholder="All City" />
                )}
              />
            </Grid>
          )}
        </>
      )}
      <Grid sx={{ marginTop: { xs: '0px', md: '0px', sm: '0px' } }}>
        <CommonDateRangePicker onSelectDateRange={onSelectDateRange} dateFrom={props?.dateFrom}
          dateTo={props?.dateTo} tab={tab} />
      </Grid>
    </Grid>
  ) : (
    <Grid
      container
      spacing={{ xs: 1, sm: 1, md: 2 }}
      sx={{
        justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'flex-start', xs: 'flex-start' },
        flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' }
      }}
    >
      <Grid item xs={12} sm={12} md="auto" lg="auto" sx={{ flex: { lg: 1, md: 1, sm: 'none', xs: 'none' }, minWidth: { xs: '100%', sm: '100%', md: 'auto' } }}>
        <CommonSDF
          {...props}
          onSearchQuery={onSearchQuery}
          search={search}
          onSelectDateRange={onSelectDateRange}
          dateFrom={props?.dateFrom}
          dateTo={props?.dateTo}
          filter={filter}
          defaultStatus={defaultStatus}
          filterdata={filterData}
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          defaultLocation={defaultLocation}
        />
      </Grid>
      {buttonName?.length > 0 && (
        <Grid item xs={12} sm={12} md="auto" lg="auto" sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-end', lg: 'flex-end' }, width: { xs: '100%', sm: '100%', md: 'auto' } }}>
          <CommonButton
            name={buttonName}
            btnClass="btnMedium btnYellow btnPayment"
            type="submit"
            iconPlace="front"
            iconType="add"
            onClick={navigation}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default CommonSubHeader;
